import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
//import LocomotiveScroll from "locomotive-scroll"

let titres = document.querySelectorAll('.groupe__titre')
let textes = document.querySelectorAll('.groupe__texte')
let conteneurScroll = document.querySelector('.conteneur_scroll');
let conteneur = document.querySelector('.section__savoirfaire_conteneur')
export const unmount = () => {
    killTrigger()
}


export const init = function () {

    initScrollTriger('lien_trigger_corporate')
    cacheGroupe()
    cacheListe('creation')
    cacheListe('corporate')
    clean()

    // test un lien depuis la home
    lienAncre()

    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.section__savoirfaire_conteneur',
            start: "top-=200 top",
            // makes the height of the scrolling (while pinning) match the width, thus the speed remains constant (vertical/horizontal)
            end: () => "+=" + window.innerHeight * 6,
            scrub: true,
            pin: true,
            anticipatePin: 1,
            markers: false,
            id: 'pin'
        },
        defaults: { ease: "none" }
    });

    // click
    document.querySelectorAll('.section__bloc-video').forEach(element => {
        element.addEventListener("click", function (e) {
                goSection(element.id, 'direct')
        })
    });
}



const lienAncre = () => {
    var ancre = document.URL.split('#')
    if (ancre.length > 1) {
        setTimeout(() => {
           
            goSection('lien_trigger_'+ancre[1], 'slide')
        }, 500);
        
    }
}

const goSection = (id,type) => {
    
    const promise1 = new Promise((resolve, reject) => {
   
        ordreTrigger(id)
        initScrollTriger(id)
        resolve('Success!');
    });
    promise1.then((value) => {
        if (type=='slide') {
            setTimeout(() => {
                gsap.to(window, {
                    duration: 2,
                    scrollTo: {
                        y: '#' + id.slice(5)
                        , offsetY: 250
                    },
                    ease: "power1.inOut"
                });
            }, 1500);
        }

        else {
            gsap.to(window, {
                duration: 1,
                scrollTo: {
                    y: '#' + id.slice(5)
                    , offsetY: 250
                },
                ease: "power1.inOut"
            });
        }
       
      
    });
}

const ordreTrigger = (type) => {
    var topTrigger = 300;
    var stepTrigger = 400;

    var triggersCorporate = document.querySelector('.zone__trigger--corporate')
    var triggersCreation = document.querySelector('.zone__trigger--creation')
    conteneurScroll = document.querySelector('.conteneur_scroll')

    var i = 1
    if (type == 'lien_trigger_corporate') {
        //swapNodes(triggersCorporate, triggersCreation)
        conteneurScroll = document.querySelector('.conteneur_scroll')
    var aHolder = document.createElement("div");
    var bHolder = document.createElement("div");

    conteneurScroll.replaceChild(aHolder, triggersCorporate);
    conteneurScroll.replaceChild(bHolder, triggersCreation);

    conteneurScroll.replaceChild(triggersCorporate, aHolder);
    conteneurScroll.replaceChild(triggersCreation, bHolder);
   
    }
    if (type == 'lien_trigger_creation') {
        //swapNodes(triggersCreation, triggersCorporate)

        conteneurScroll = document.querySelector('.conteneur_scroll')

        var aHolder = document.createElement("div");
        var bHolder = document.createElement("div");
    
        conteneurScroll.replaceChild(aHolder, triggersCorporate);
        conteneurScroll.replaceChild(bHolder, triggersCreation);
    
        conteneurScroll.replaceChild(triggersCreation, aHolder);
        conteneurScroll.replaceChild(triggersCorporate, bHolder);

          
    }


    var triggers = document.querySelectorAll('.trigger')

    triggers.forEach(trigger => {

        if (type == 'lien_trigger_corporate') {
            if (trigger.classList.contains('trigger_corporate')) {
                trigger.style.top = topTrigger + "px";
                topTrigger += 400
            }
            if (trigger.classList.contains('trigger_creation')) {
                topTrigger += 400
                trigger.style.top = topTrigger + "px";
                topTrigger += 200
            }
        }

        if (type == 'lien_trigger_creation') {
            if (trigger.classList.contains('trigger_creation')) {
                trigger.style.top = topTrigger + "px";
               // topTrigger += 400
            }
            if (trigger.classList.contains('trigger_corporate')) {
                topTrigger += 400
                trigger.style.top = topTrigger + "px";
               // topTrigger += 200
            }
        }

        if (trigger.classList.contains('trigger_titre')) {
            if ((trigger.dataset.groupe == 'corpo_intro') || (trigger.dataset.groupe == 'crea_intro')) {
                trigger.style.top = topTrigger + "px";
                topTrigger += 200
                i = 1
            }
            else {
               
                topTrigger += ( stepTrigger)
                console.log(topTrigger,i*stepTrigger)
                trigger.style.top = topTrigger + "px";
                i++
            }
        }


    });
}


// function swapNodes(a, b) {

//     conteneurScroll = document.querySelector('.conteneur_scroll')
//     console.log(conteneurScroll)

//     var aHolder = document.createElement("div");
//     var bHolder = document.createElement("div");

//     conteneurScroll.replaceChild(aHolder, a);
//     conteneurScroll.replaceChild(bHolder, b);

//     conteneurScroll.replaceChild(b, aHolder);
//     conteneurScroll.replaceChild(a, bHolder);
//       console.log(conteneurScroll)
// }

const initCorporate = () => {
    cacheListe('creation')
    document.querySelector('.section__savoirfaire_conteneur').classList.remove('is-creation')
    document.querySelector('.section__savoirfaire_conteneur').classList.add('is-corporate')
    document.querySelector('.video__corporate').play()
    document.querySelector('.video__creation').pause()
    document.querySelector('.section__savoirfaire_liste--corporate').classList.add('is-active')
    document.querySelector('.video__contenu__zone-texte--corporate').classList.add('is-active')
}

const initCreation = () => {
    cacheListe('corporate')
    document.querySelector('.section__savoirfaire_conteneur').classList.remove('is-corporate')
    document.querySelector('.section__savoirfaire_conteneur').classList.add('is-creation')
    document.querySelector('.video__corporate').pause()
    document.querySelector('.video__creation').play()
    document.querySelector('.section__savoirfaire_liste--creation').classList.add('is-active')
    document.querySelector('.video__contenu__zone-texte--creation').classList.add('is-active')
}

const cacheGroupe = () => {
    titres = document.querySelectorAll('.groupe__titre')
    textes = document.querySelectorAll('.groupe__texte')
    titres.forEach(element => {
        element.classList.remove('is-active')
    });
    textes.forEach(element => {
        element.classList.remove('is-active')
    });
}

const afficheGroupe = (groupe) => {
    if (document.querySelector('[data-titre="' + groupe + '"]')) document.querySelector('[data-titre="' + groupe + '"]').classList.add('is-active')
    if (document.querySelector('[data-texte="' + groupe + '"]')) document.querySelector('[data-texte="' + groupe + '"]').classList.add('is-active')
}

const cacheListe = (liste) => {
    document.querySelector('.section__savoirfaire_liste--' + liste).classList.remove('is-active')
    document.querySelector('.video__contenu__zone-texte--' + liste).classList.remove('is-active')
}

export const clean = () => {
    if (document.querySelector('.section__savoirfaire_conteneur').classList.contains('is-corporate')) document.querySelector('.section__savoirfaire_conteneur').classList.remove('is-corporate')
    if (document.querySelector('.section__savoirfaire_conteneur').classList.contains('is-creation')) document.querySelector('.section__savoirfaire_conteneur').classList.remove('is-creation')
    document.querySelector('.video__corporate').pause()
    document.querySelector('.video__creation').pause()

    cacheGroupe()
    cacheListe('corporate')
    cacheListe('creation')
}

const killTrigger = () => {
    // si déjà instanciés, on détruit
    if (ScrollTrigger.getById("corporate")) {
        ScrollTrigger.getById("corporate").kill()
        ScrollTrigger.getById("creation").kill()

        const triggersTexte = document.querySelectorAll('.trigger_titre')
        triggersTexte.forEach(element => {
            ScrollTrigger.getById(element.dataset.groupe).kill()
        })
    }
}


const initScrollTriger = (type) => {
    
    
    killTrigger()
    
    const corporate = document.querySelector('.trigger_corporate')
    ScrollTrigger.create({
        trigger: corporate,
        start: 'top-=200px center',
        end: 'bottom+=200px center',
        id: 'corporate',
        onEnter: () => {
            initCorporate()
        },
        onLeaveBack: () => {
            
            if (type == 'lien_trigger_corporate') clean()
            else  initCreation()
        },
        onLeave: () => {

        },
        markers: false // !! MARQUERUS
    })

    const creation = document.querySelector('.trigger_creation')
    ScrollTrigger.create({
        trigger: creation,
        start: 'top-=200px center',
        end: 'bottom+=200px center',
        id: 'creation',
        onEnter: () => {
            initCreation()

        },
        onLeaveBack: ({ progress, direction, isActive }) => {
  
            if (type == 'lien_trigger_creation') {clean() }
            else {
                console.log('initcorpo')
                initCorporate()
            }
        },
        onLeave: () => {
        },
        markers: false // !! MARQUERUS
    })

    const triggersTexte = document.querySelectorAll('.trigger_titre')
    triggersTexte.forEach(element => {
        ScrollTrigger.create({
            trigger: element,
            start: 'top-=200px center',
            end: 'bottom+=200px center',
            id: element.dataset.groupe,
            onEnter: () => {
                //console.log('onEnter', element.dataset.groupe)
                cacheGroupe()
                afficheGroupe(element.dataset.groupe)
                //gsap.to( document.querySelector('.section-carte_masque'), {x:'-50%', y:'0%',z:0} )
            },
            onLeaveBack: () => {
                //console.log('onLeaveBack', element.dataset.groupe)
                cacheGroupe()
                afficheGroupe(element.dataset.groupe)
                //gsap.to( document.querySelector('.section-carte_masque'),  {x:'0%', y:'0%',z:0})
            },
            onLeave: () => {
                //console.log('onLeave', element.dataset.groupe)
                cacheGroupe()
            },
            markers: false // !! MARQUERUS
        })
    });
}

